// extracted by mini-css-extract-plugin
module.exports = {"asc-app":"AscToogleBox_asc-app__ixvIJ","dark-mode":"AscToogleBox_dark-mode__Ojdoh","switch":"AscToogleBox_switch__dHapy","slider":"AscToogleBox_slider__Loybp"};